import styled from 'styled-components';
import EditIcon from 'js/components/core/Icons/EditIcon';
import { width } from '../SaveButton';

export default styled(EditIcon)`
  float: right;
  width: ${width};
  height: 30px;
`;
